import Axios from "axios";
import Apis from "../../config/Apis";
import {
  hideLoading,
  showLoading,
  showAlert,
  UpdateTypes,
} from "../Actions/GeneralActions";
import {
  getUpComingEvents,
  getEventHistory,
  getEventDetail,
  updateEvent,
  editEvent,
  deleteEvent,
  getBudget,
  getEventReminder,
  getClientPlanningForm,
  getClientSection,
  getClientQuestion,
  getBudgetCat,
  getSubClientSection,
  getEventTimeline,
  getEventWedWall,
  getEventWedWeb,
} from "../Actions/EventAction";
import { getClientDashboardData } from "../Actions/DashboardAction";
import { headers } from "../../utills";
import moment from "moment";

export const EventMiddleware = {
  getEvents: (userData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          if (userData?.name) formData.append("name", userData?.name);
          formData.append("status", userData?.status);
          const data = await Axios.post(
            Apis.events,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            if (userData?.status == "upcoming") {
              dispatch(getUpComingEvents(data?.data?.data));
            } else {
              dispatch(getEventHistory(data?.data?.data));
            }
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              message: error?.response?.data?.message,
              type: "Error",
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getEventDetails: ({ id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            `${Apis.eventDetails + id}`,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
            dispatch(getEventDetail(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getEvents",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  createEvent: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("image", eventData?.eventImage);
          formdata.append("name", eventData?.EventName);
          formdata.append("category_id", eventData?.SelectedEventCategoryID);
          formdata.append("description", eventData?.Description);
          formdata.append("date", eventData?.date);
          formdata.append("start_time", eventData?.startTime);
          formdata.append("end_time", eventData?.endTime);
          formdata.append("address", eventData?.address);
          formdata.append("lat", eventData?.lat);
          formdata.append("lng", eventData?.lng);
          formdata.append("reception_address", eventData?.receptionAddress);
          formdata.append("reception_latitude", eventData?.receptionLat);
          formdata.append("reception_longitude", eventData?.receptionLng);
          formdata.append(
            "reception_start_time",
            eventData?.receptionStartTime
          );
          formdata.append("reception_end_time", eventData?.receptionEndTime);
          formdata.append("no_of_guest", eventData?.guest);
          formdata.append("status", eventData?.SelectedStatus);
          formdata.append("bride_image", eventData?.brideImage);
          formdata.append("bride_first_name", eventData?.brideFName);
          formdata.append("bride_last_name", eventData?.brideLName);
          formdata.append("bride_email", eventData?.brideEmail);
          formdata.append("bride_contact_no", eventData?.brideContactNumber);
          formdata.append("groom_image", eventData?.groomImage);
          formdata.append("groom_first_name", eventData?.groomFName);
          formdata.append("groom_last_name", eventData?.groomLName);
          formdata.append("groom_email", eventData?.groomEmail);
          formdata.append("groom_contact_no", eventData?.groomContactNumber);
          const data = await Axios.post(
            Apis.createEvent,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(updateEvent(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Create Event",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Create Event",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  editEvent: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", eventData?.id);
          if (eventData?.eventImage)
            formdata.append("image", eventData?.eventImage);
          formdata.append("name", eventData?.EventName);
          formdata.append("category_id", eventData?.SelectedEventCategoryID);
          formdata.append("description", eventData?.Description);
          formdata.append("date", eventData?.date);
          formdata.append("start_time", eventData?.startTime);
          formdata.append("end_time", eventData?.endTime);
          formdata.append("address", eventData?.address);
          formdata.append("lat", eventData?.lat);
          formdata.append("lng", eventData?.lng);
          formdata.append("reception_address", eventData?.receptionAddress);
          formdata.append("reception_latitude", eventData?.receptionLat);
          formdata.append("reception_longitude", eventData?.receptionLng);
          formdata.append(
            "reception_start_time",
            eventData?.receptionStartTime
          );
          formdata.append("reception_end_time", eventData?.receptionEndTime);
          formdata.append("no_of_guest", eventData?.guest);
          formdata.append("status", eventData?.SelectedStatus);
          if (eventData?.brideImage)
            formdata.append("bride_image", eventData?.brideImage);
          formdata.append("bride_first_name", eventData?.brideFName);
          formdata.append("bride_last_name", eventData?.brideLName);
          formdata.append("bride_email", eventData?.brideEmail);
          formdata.append("bride_contact_no", eventData?.brideContactNumber);
          if (eventData?.groomImage)
            formdata.append("groom_image", eventData?.groomImage);
          formdata.append("groom_first_name", eventData?.groomFName);
          formdata.append("groom_last_name", eventData?.groomLName);
          formdata.append("groom_email", eventData?.groomEmail);
          formdata.append("groom_contact_no", eventData?.groomContactNumber);
          // console.log("object", formdata);
          const data = await Axios.post(
            Apis.updateEvent,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getEventDetail(data?.data?.data));
            dispatch(editEvent(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Edit Event",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Edit Event",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  deleteEvent: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", eventData?.id);
          const data = await Axios.post(
            Apis.deleteEvent,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(deleteEvent(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Delete Event",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Delete Event",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  createCountDown: (countdownData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("groom", countdownData?.GroomName);
          formdata.append("bride", countdownData?.BrideName);
          formdata.append("date", countdownData?.date);
          formdata.append("time", countdownData?.time);
          formdata.append("event_id", countdownData?.id);
          const data = await Axios.post(
            Apis.createCountDown,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getClientDashboardData(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Create Event",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Create Event",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  editCountDown: (countdownData) => {
    // console.log("countdownnnn", countdownData);
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("groom", countdownData?.GroomName);
          formdata.append("bride", countdownData?.BrideName);
          formdata.append("date", countdownData?.date);
          formdata.append("time", countdownData?.time);
          formdata.append("event_id", countdownData?.id);
          formdata.append("id", countdownData?.countdown_id);
          const data = await Axios.post(
            Apis.updateCountDown,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getClientDashboardData(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Edit Event",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Edit Event",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  budget: ({ event_id, name }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          if (name) formData.append("name", name);
          formData.append("event_id", event_id);
          const data = await Axios.post(
            Apis.budgets,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getBudget(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "budget",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  createBudget: ({
    event_id,
    category_id,
    title,
    amount,
    vendor_id,
    actual_cost,
  }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", event_id);
          formData.append("category_id", category_id);
          formData.append("title", title);
          formData.append("amount", amount);
          if (vendor_id) formData.append("vendor_id", vendor_id);
          const data = await Axios.post(
            Apis.createBudgets,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getBudget(data?.data?.data));
            dispatch(
              showAlert({
                title: "createBudget",
                message: data?.data?.message,
                type: "Success",
                status: data.status,
              })
            );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createBudget",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  updateBudget: ({ id, title, amount }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("id", id);
          formData.append("title", title);
          formData.append("amount", amount);
          const data = await Axios.post(
            Apis.updateBudgets,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getBudget(data?.data?.data));
            dispatch(
              showAlert({
                title: "createBudget",
                message: data?.data?.message,
                type: "Success",
                status: data.status,
              })
            );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createBudget",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  deleteBudget: ({ id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("id", id);
          const data = await Axios.post(
            Apis.deleteBudget,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getBudget(data?.data?.data));
            dispatch(
              showAlert({
                title: "createBudget",
                message: data?.data?.message,
                type: "Success",
                status: data.status,
              })
            );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createBudget",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  deleteBudgetPayment: ({ id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("id", id);
          const data = await Axios.post(
            Apis.deleteBudgetPayments,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getBudget(data?.data?.data));
            dispatch(
              showAlert({
                title: "deleteBudgetPayments",
                message: data?.data?.message,
                type: "Success",
                status: data.status,
              })
            );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createBudget",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  createCategory: (payload) => {
    return (dispatch) => {
      // dispatch(showLoading())
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formData = new FormData();
          formData.append("name", payload.name);
          formData.append("event_id", payload.event_id);
          const data = await Axios.post(
            Apis.createBudgetCategory,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            // dispatch(UpdateTypes({ budgetCategories: data?.data?.data }));
            dispatch(
              showAlert({
                title: "createCategory",
                message: data?.data?.message,
                type: "Success",
                status: data.status,
              })
            );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createCategory",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getBudgetCategory: (event_id) => {
    return (dispatch) => {
      // dispatch(showLoading())
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          const data = await Axios.get(
            Apis.getBudgetCategories(event_id),
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getBudgetCat(data?.data?.data));
            // dispatch(
            //   showAlert({
            //     title: "createCategory",
            //     message: data?.data?.message,
            //     type: "Success",
            //     status: data.status,
            //   })
            // );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "createCategory",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  addBudgetPayment: ({ budget_id, status, due_date, amount, actual_cost }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("budget_id", budget_id);
          // formData.append("status", status);
          formData.append("due_date", due_date);
          formData.append("amount", amount);
          formData.append("actual_cost", actual_cost);
          const data = await Axios.post(
            Apis.createBudgetPayments,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getBudget(data?.data?.data));
            dispatch(
              showAlert({
                title: "addBudgetPayment",
                message: data?.data?.message,
                type: "Success",
                status: data.status,
              })
            );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "addBudgetPayment",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  budgetPayments: ({ event_id, status }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("status", status);
          formData.append("event_id", event_id);
          const data = await Axios.post(
            Apis.budgetPayments,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "budget",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  payEventBudget: ({ budget_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("budget_id", budget_id);
          const data = await Axios.post(
            Apis.payEventBudget,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getBudget(data?.data?.data));
            dispatch(
              showAlert({
                title: "payEventBudget",
                message: data?.data?.message,
                type: "Success",
                status: data.status,
              })
            );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "payEventBudget",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  vendorBudgetDetail: ({ event_id, vendor_id }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", event_id);
          formData.append("vendor_id", vendor_id);
          const data = await Axios.post(
            Apis.vendorBudgetDetail,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "vendorBudgetDetail",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  getUserEvents: () => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.getUserEvents,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getUserEvents",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  getEventGuest: ({ event_id, search, loading }) => {
    return (dispatch) => {
      if (loading) dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (search) formdata.append("name", search);
          formdata.append("event_id", event_id);
          const data = await Axios.post(
            Apis.getEventGuests,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getEventGuest",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          if (loading) dispatch(hideLoading());
        }
      });
    };
  },

  getReminder: (eventData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", eventData?.event_id);
          formdata.append("date", eventData?.date);
          const data = await Axios.post(
            Apis.eventReminders,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getEventReminder(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Get Reminder",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  createReminder: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", eventData?.event_id);
          formdata.append("name", eventData?.reminderTitle);
          formdata.append("date", eventData?.date);
          if (eventData?.time) {
            formdata.append("time", eventData?.time);
          }
          const data = await Axios.post(
            Apis.createEventReminder,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getEventReminder(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Create Reminder",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  updateReminder: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", eventData?.id);
          formdata.append("name", eventData?.name);
          formdata.append("date", eventData?.date);
          if (eventData.time) formdata.append("time", eventData?.time);
          const data = await Axios.post(
            Apis.updateEventReminder,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getEventReminder(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Create Reminder",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  deleteReminder: (id) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", id);
          const data = await Axios.post(
            Apis.deleteEventReminder,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getEventReminder(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Create Reminder",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  createTimeline: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (eventData.id) {
            formdata.append("id", eventData?.id);
          } else {
            formdata.append("event_id", eventData?.event_id);
          }
          formdata.append("title", eventData?.title);
          if (eventData?.description) {
            formdata.append("description", eventData?.description);
          }
          if (eventData?.time) formdata.append("time", eventData?.time);
          const data = await Axios.post(
            eventData?.id ? Apis.updateTimeline : Apis.createTimeline,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getEventTimeline(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Create Reminder",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getTimeline: (id) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", id);
          const data = await Axios.post(
            Apis.eventTimelines,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getEventTimeline(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Get Timeline",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },
  deleteTimeline: (timelineData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("id", timelineData?.id);
          formdata.append("event_id", timelineData?.event_id);
          const data = await Axios.post(
            Apis.deleteTimeline,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getEventTimeline(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Get Timeline",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  sorteTimeline: (sections, eventId) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append(`event_id`, eventId);

          for (const [i, element] of sections.entries()) {
            formdata.append(`timelines[${i}][id]`, element?.id);
            formdata.append(`timelines[${i}][sort_no]`, i);
          }
          const data = await Axios.post(
            Apis.sortTimeline,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(
              showAlert({
                title: "sortedSections",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "sortedSections",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  generateTimelinePdf: (event_id) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", event_id);
          const data = await Axios.post(
            Apis.downloadTimelinePdf,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            let file = {
              attachment: data?.data?.data?.url,
            };
            // dispatch(EventPlanningMiddleware.DownloadAttachment({ file }));
            dispatch(
              showAlert({
                title: "generatePdf",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
            resolve(file);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "generatePdf",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  goLive: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", eventData?.event_id);
          const data = await Axios.post(
            Apis.eventBroadcast,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Go Live",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  joinStrean: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", eventData?.event_id);
          const data = await Axios.post(
            Apis.joinBroadcast,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Join Stream",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  leaveStrean: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", eventData?.event_id);
          const data = await Axios.post(
            Apis.leaveBroadcast,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "leave Stream",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  endBroadcast: (eventData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", eventData?.event_id);
          const data = await Axios.post(
            Apis.endBroadcast,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Stream Ended",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getClientPlanningForm: (eventData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("event_id", eventData?.event_id);
          const data = await Axios.post(
            Apis.getTemplateByEvent,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(getClientPlanningForm(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Get Client Planning Form",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  getClientsection: (tempData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("planningtemplate_id", tempData?.planningtemplate_id);
          formData.append("event_id", tempData?.event_id);
          const data = await Axios.post(
            Apis.getSectionsByTemplate,
            formData,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
            dispatch(getClientSection(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Get Client Planning Form",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },
  getSubSections: (tempData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (tempData?.event_id)
            formdata.append("event_id", tempData?.event_id);
          formdata.append("parent_id", tempData?.id);
          const data = await Axios.post(
            Apis.getSubSections,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
            dispatch(getSubClientSection(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Get Section",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getClientQuestions: (secData) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("templatesection_id", secData?.templatesection_id);
          formdata.append("event_id", secData?.event_id);
          const data = await Axios.post(
            Apis.getQuestion,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
            dispatch(getClientQuestion(data?.data?.data?.questions));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Get Client Section",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  postAnswerByClient: ({ answerCollection, planningtemplate_id, event_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", event_id);
          formdata.append("planningtemplate_id", planningtemplate_id);
          for (const [i, element] of answerCollection.entries()) {
            if (element.answerUpdate) {
              if (element?.type == "own_words") {
                formdata.append(`answers[${i}][question_id]`, element?.id);
                formdata.append(`answers[${i}][answer]`, element?.answer);
              }
              if (element?.type == "set_option") {
                formdata.append(`answers[${i}][question_id]`, element?.id);
                formdata.append(`answers[${i}][answer]`, element?.answer);
              }

              if (element?.type == "multiple_option") {
                for (const [i, option] of element.options.entries()) {
                  formdata.append(`answers[${i}][question_id]`, element?.id);
                  formdata.append(`answers[${i}][answer]`, option.name);
                  formdata.append(
                    `answers[${i}][is_deleted]`,
                    element.answer?.includes(option.name) ? false : true
                  );
                }
              }
            }
          }
          const data = await Axios.post(
            Apis.clientSubmitAnswers,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(getClientSection(data?.data?.data));
            resolve(true);
            dispatch(
              showAlert({
                title: "Post answer by client",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              })
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Post answer by client",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getAllVendor: ({ role, search, loading }) => {
    return (dispatch) => {
      if (loading) dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("name", search);
          formdata.append("role", role);
          const data = await Axios.post(
            Apis.getUsersByRole,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "get All vendor",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          if (loading) dispatch(hideLoading());
        }
      });
    };
  },

  getEventWeddingWall: (id) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("event_id", id);

          const data = await Axios.post(
            Apis.weddingWall,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(getEventWedWall(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getEvents",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getWeddingWebsite: (id) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.weddingWebsite(id),
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(getEventWedWeb(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getEvents",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  postWeddingWebsite: (payload) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          switch (payload.step) {
            case 1:
              formdata.append("event_id", payload?.event_id);
              formdata.append("date", payload?.date);
              formdata.append("description", payload?.description);
              if (payload?.image) formdata.append("image", payload?.image);
              const data = await Axios.post(
                Apis.saveWeddingWebsite(""),
                formdata,
                await headers.config()
              );
              if (data?.status == 200) {
                resolve(true);
                dispatch(getEventWedWeb(data?.data?.data));
              }
              break;

            case 2:
              formdata.append("wedding_website_id", payload?.weddingWebId);
              for (const [i, element] of payload?.detailsArr.entries()) {
                formdata.append(`stories[${i}][title]`, element?.title);
                formdata.append(
                  `stories[${i}][description]`,
                  element?.description
                );
              }
              const data2 = await Axios.post(
                Apis.saveWeddingWebsite("Stories"),
                formdata,
                await headers.config()
              );
              if (data2?.status == 200) {
                resolve(true);
                dispatch(getEventWedWeb(data2?.data?.data));
              }
              break;

            case 3:
              console.log(payload?.detailsArr);
              formdata.append("wedding_website_id", payload?.weddingWebId);
              for (const [i, element] of payload?.detailsArr.entries()) {
                formdata.append(`parties[${i}][name]`, element?.name);
                if (element?.id)
                  formdata.append(`parties[${i}][id]`, element?.id);
                formdata.append(`parties[${i}][title]`, element?.title);
                if (element?.newImage)
                  formdata.append(`parties[${i}][image]`, element?.newImage);
                formdata.append(
                  `parties[${i}][description]`,
                  element?.description
                );
              }
              const data3 = await Axios.post(
                Apis.saveWeddingWebsite("Parties"),
                formdata,
                await headers.config()
              );
              if (data3?.status == 200) {
                resolve(true);
                dispatch(getEventWedWeb(data3?.data?.data));
              }
              break;

            case 4:
              formdata.append("wedding_website_id", payload?.weddingWebId);
              for (const [i, element] of payload?.detailsArr.entries()) {
                formdata.append(`agendas[${i}][title]`, element?.title);
                formdata.append(
                  `agendas[${i}][description]`,
                  element?.description
                );
                formdata.append(
                  `agendas[${i}][date]`,
                  moment(
                    element?.date?.$d ? element?.date?.$d : element?.date
                  ).format("YYYY-MM-DD")
                );
                formdata.append(
                  `agendas[${i}][time]`,
                  moment(
                    element?.time?.$d
                      ? element?.time?.$d
                      : `${element?.time} ${element?.date}`
                  ).format("HH:mm")
                );
                formdata.append(
                  `agendas[${i}][location_title]`,
                  element?.location_title
                );
                formdata.append(`agendas[${i}][location]`, element?.location);
                formdata.append(`agendas[${i}][lat]`, element?.lat);
                formdata.append(`agendas[${i}][lng]`, element?.lng);
              }
              const data4 = await Axios.post(
                Apis.saveWeddingWebsite("Agendas"),
                formdata,
                await headers.config()
              );
              if (data4?.status == 200) {
                resolve(true);
                dispatch(getEventWedWeb(data4?.data?.data));
              }
              break;

            case 5:
              formdata.append("wedding_website_id", payload?.weddingWebId);
              for (const [i, element] of payload?.detailsArr.entries()) {
                formdata.append(`faqs[${i}][question]`, element?.question);
                formdata.append(`faqs[${i}][answer]`, element?.answer);
              }
              const data5 = await Axios.post(
                Apis.saveWeddingWebsite("Faqs"),
                formdata,
                await headers.config()
              );
              if (data5?.status == 200) {
                resolve(true);
                dispatch(getEventWedWeb(data5?.data?.data));
              }
              break;

            case 6:
              formdata.append("wedding_website_id", payload?.weddingWebId);
              formdata.append("accommodation", payload?.description);
              const data6 = await Axios.post(
                Apis.saveWeddingWebsite("Accommodation"),
                formdata,
                await headers.config()
              );
              if (data6?.status == 200) {
                resolve(true);
                dispatch(getEventWedWeb(data6?.data?.data));
              }
              break;

            default:
              break;
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getEvents",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
